import { rootDomain } from '~/utils/cookie';

export const useCookieStag = () => {
  const removeStag = () => {
    if (!window || !process.browser) {
      return;
    }

    const domain = rootDomain(document.location.hostname);

    window.document.cookie = `stag='';Max-Age=0;Domain=${domain};Path=/`;
  };

  return {
    removeStag,
  };
};
